import React, { useEffect, useState } from "react";

interface DateRange {
  startDate: string;
  endDate: string;
}

interface DateRangePickerProps {
  value?: DateRange;
  onChange: (range: DateRange) => void;
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({
  value,
  onChange,
}) => {
  const [startDate, setStartDate] = useState<string>(
    value?.startDate ? value.startDate.split("T")[0] : ""
  );
  const [endDate, setEndDate] = useState<string>(
    value?.endDate ? value.endDate.split("T")[0] : ""
  );

  useEffect(() => {
    onChange({
      startDate: startDate ? new Date(startDate).toISOString() : "",
      endDate: endDate ? new Date(endDate).toISOString() : "",
    });
  }, [startDate, endDate]);

  return (
    <div className="group relative">
      <div className="relative flex flex-wrap items-center gap-3">
        <div className="flex">From:</div>

        <div className="flex flex-wrap items-center gap-3">
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="bg-gray-50/50 backdrop-blur border border-gray-200 rounded-md px-3 py-2 text-sm text-gray-700 focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all duration-200 hover:bg-gray-100/50"
          />

          <span className="sm:px-2">To:</span>

          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="bg-gray-50/50 backdrop-blur border border-gray-200 rounded-md px-3 py-2 text-sm text-gray-700 focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all duration-200 hover:bg-gray-100/50"
          />
        </div>
      </div>
    </div>
  );
};

export default DateRangePicker;
